import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EventBusyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"event_busy"}/>
}
